import _slicedToArray from "/codebuild/output/src1380349135/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/customer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/codebuild/output/src1380349135/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/customer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src1380349135/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/customer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src1380349135/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/customer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import Reference from '../Reference';
var ReferenceSet = /*#__PURE__*/function () {
  function ReferenceSet() {
    _classCallCheck(this, ReferenceSet);
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }
  return _createClass(ReferenceSet, [{
    key: "size",
    get: function get() {
      return this.list.size + this.refs.size;
    }
  }, {
    key: "describe",
    value: function describe() {
      var description = [];
      var _iterator = _createForOfIteratorHelper(this.list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          description.push(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(this.refs),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            ref = _step2$value[1];
          description.push(ref.describe());
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return description;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
  }, {
    key: "resolveAll",
    value: function resolveAll(resolve) {
      return this.toArray().reduce(function (acc, e) {
        return acc.concat(Reference.isRef(e) ? resolve(e) : e);
      }, []);
    }
  }, {
    key: "add",
    value: function add(value) {
      Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
  }, {
    key: "clone",
    value: function clone() {
      var next = new ReferenceSet();
      next.list = new Set(this.list);
      next.refs = new Map(this.refs);
      return next;
    }
  }, {
    key: "merge",
    value: function merge(newItems, removeItems) {
      var next = this.clone();
      newItems.list.forEach(function (value) {
        return next.add(value);
      });
      newItems.refs.forEach(function (value) {
        return next.add(value);
      });
      removeItems.list.forEach(function (value) {
        return next.delete(value);
      });
      removeItems.refs.forEach(function (value) {
        return next.delete(value);
      });
      return next;
    }
  }]);
}();
export { ReferenceSet as default };